export default __webpack_public_path__ + "static/media/AcIcon.d72f9f96.svg";